import React, { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';

export const DemoAutoLogin: React.FC = () => {
  const { loginDemo, currentUser, isDemoMode } = useAuth();

  useEffect(() => {
    // Auto-login to demo mode if no user is logged in
    if (!currentUser && !isDemoMode) {
      console.log('🎯 Auto-logging into demo mode...');
      loginDemo();
    }
  }, [currentUser, isDemoMode, loginDemo]);

  return null; // This component doesn't render anything
};
